import { __mediamax_api_url_config__ } from '@/constants/appConfig'
import apiClient from '../../shared/apiClient'
import type { ApiError } from '../../shared/apiClient'
import type {
  BrandAccessStatusResponse,
  BrandRequestApiError,
  BrandAccessRequestPayload,
  BrandAccessRequestResponse,
  AvailableBrandsResponse,
  BrandAccessOnboardingStatusResponse,
  AvailableBrandsRequestParams,
} from './types'

export async function getBrandAccessStatusApi(): Promise<BrandAccessStatusResponse> {
  try {
    const response = await apiClient.get<BrandAccessStatusResponse>(
      __mediamax_api_url_config__.getBrandAccessStatus
    )

    return response
  } catch (error) {
    if (error && typeof error === 'object' && 'message' in error) {
      const apiError = error as ApiError
      throw {
        message: apiError.message || 'Failed to fetch brand access status',
        status: apiError.status,
        code: apiError.code,
      } as BrandRequestApiError
    }
    throw error
  }
}

export async function getBrandAccessOnboardingStatusApi(): Promise<BrandAccessOnboardingStatusResponse> {
  try {
    const response = await apiClient.get<BrandAccessOnboardingStatusResponse>(
      __mediamax_api_url_config__.getBrandAccessOnboardingStatus
    )

    return response
  } catch (error) {
    if (error && typeof error === 'object' && 'message' in error) {
      const apiError = error as ApiError
      throw {
        message: apiError.message || 'Failed to fetch brand access onboarding status',
        status: apiError.status,
        code: apiError.code,
      } as BrandRequestApiError
    }
    throw error
  }
}

export async function requestBrandAccessApi(
  payload: BrandAccessRequestPayload
): Promise<BrandAccessRequestResponse> {
  try {
    const response = await apiClient.post<BrandAccessRequestResponse, BrandAccessRequestPayload>(
      __mediamax_api_url_config__.requestBrandAccess,
      payload
    )
    return response
  } catch (error) {
    if (error && typeof error === 'object' && 'message' in error) {
      const apiError = error as ApiError
      throw {
        message: apiError.message || 'Failed to request brand access',
        status: apiError.status,
        code: apiError.code,
      } as BrandRequestApiError
    }
    throw error
  }
}

export async function getAvailableBrandsApi(
  params: AvailableBrandsRequestParams
): Promise<AvailableBrandsResponse> {
  if (!params) {
    throw new Error('Query parameters are required to fetch available brands.')
  }

  try {
    const { pageNumber, pageSize, search } = params

    const response = await apiClient.get<AvailableBrandsResponse>(
      __mediamax_api_url_config__.getAvailableBrands,
      {
        params: {
          page_number: pageNumber,
          page_size: pageSize,
          search: search,
        },
      }
    )

    return response
  } catch (error) {
    if (error && typeof error === 'object' && 'message' in error) {
      const apiError = error as ApiError
      throw {
        message: apiError.message || 'Failed to fetch available brands',
        status: apiError.status,
        code: apiError.code,
      } as BrandRequestApiError
    }
    throw error
  }
}
